export default function CtaStrip() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="relative overflow-hidden rounded-2xl">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20gradient%20background%20with%20soft%20green%20light%20rays%20and%20warm%20red%20glow%2C%20dark%20moody%20texture%2C%20subtle%20film%20grain%2C%20elegant%20atmospheric%2C%20minimal%20composition&width=1600&height=560&seq=wm-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

          <div className="relative px-6 py-10 md:px-14 md:py-16 max-w-2xl">
            <h2
              className="text-2xl md:text-3xl font-bold text-white leading-snug"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              还是没解决？照着排查顺序再过一遍
            </h2>
            <p className="mt-3 text-sm md:text-base text-white/80 leading-relaxed">
              大多数“看不了”与“卡顿”都能通过换线路、降清晰度、换播放器这三步解决。按顺序尝试，基本都能恢复流畅播放。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <a
                href="#cant-watch"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-tools-line" aria-hidden="true"></i>
                回到排查步骤
              </a>
              <a
                href="#faq"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white/10 text-white border border-white/30 text-sm font-medium hover:bg-white/20 transition-colors whitespace-nowrap"
              >
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                查看常见问答
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}